import React, { useEffect, useRef, useState } from "react";
import meet from "../images/meetScreen.png";
import calender from "../images/calender.svg";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import axios from "axios";
import Avtar from "../images/profile.svg";
import { decryptData } from "../Services/TabServices";

type Diagnosis = {
  id: string;
  title: string;
};

interface VideocallMedicationByDoctorProps {
  closePopup: () => void;
  patientId: any;
  appointmentId: any;
}

interface DoseItem {
  doseText: string;
  doseValue: number;
  doseId: number;
}

interface PharmaItem {
  itemCode: string;
  itemName: string;
}

interface ServiceItem {
  labItemId: any;
  serviceName: any;
  servicePrices: any;
}

interface MedicineObject {
  itemCode: any;
  itemName: any;
  forDays: any;
  doseId: number;
  qty: any;
}

interface ServicesObject {
  serviceId: any;
  serviceName?: any;
  serviceUnitPrice: any;
  isApplied: boolean;
}

const VideocallMedicationByDoctor: React.FC<
  VideocallMedicationByDoctorProps
> = ({ closePopup, patientId, appointmentId }) => {
  const token = sessionStorage.getItem("token");
  const storedUserId = sessionStorage.getItem("userId");
  const userId = storedUserId ? decryptData(storedUserId) : null;

  const [profileImage, setProfileImage] = useState("");
  const [patientProfile, setPatientProfile] = useState<any>([]);
  const [date, setDate] = useState("");
  const [type, setType] = useState("text");
  const [age, setAge] = useState<number | null>(null);
  const [openSection, setOpenSection] = useState<number | null>(null);
  const [chiefComplaint, setChiefComplaint] = useState("");
  const [treatmentPlan, setTreatmentPlan] = useState("");

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [selectedMedicine, setSelectedMedicine] = useState("");
  const [selectedServices, setSelectedServices] = useState("");
  const [selectedMedicineObj, setSelectedMedicineObj] = useState<
    MedicineObject[]
  >([]);
  const [medicines, setMedicines] = useState<string[]>([]);
  const medicinesString = medicines.join(", ");
  const [pharmaItems, setPharmaItems] = useState<PharmaItem[]>([]);
  const [selectedServiceObj, setSelectedServiceObj] = useState<ServicesObject[]>([]);
  const [serviceItems, setServiceItems] = useState<ServiceItem[]>([]);
  const [services, setServices] = useState<string[]>([]);
  const selectedServicesString = services.join(",");
  const [diagnosisQuery, setDiagnosisQuery] = useState("");
  const [results, setResults] = useState([]);
  const dummyDays = [1, 3, 5, 7, 10];
  const [days, setDays] = useState("");
  const [dose, setDose] = useState<DoseItem[]>([]);
  const [selectedDose, setSelectedDose] = useState("");
  const [selectedDiagnosis, setSelectedDiagnosis] = useState<string[]>([]);
  const [provisionalDiagnosis, setProvisionalDiagnosis] = useState<string[]>([]);
  const provisionalDiagnosisString = provisionalDiagnosis.join(", ");
  const [searchQuery, setSearchQuery] = useState("");

  // New states for medicine and service search
  const [medicineSearchQuery, setMedicineSearchQuery] = useState("");
  const [serviceSearchQuery, setServiceSearchQuery] = useState("");
  const [showMedicineDropdown, setShowMedicineDropdown] = useState(false);
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
const [showConfirmModal, setShowConfirmModal] = useState(false);
const [errors, setErrors] = useState<{
  diagnosis?: string;
  followUpDate?: string;
}>({});

  // Filter medicines based on search query
  const filteredMedicines = pharmaItems.filter((item) =>
    item.itemName.toLowerCase().includes(medicineSearchQuery.toLowerCase())
  );

  // Filter services based on search query
  const filteredServices = serviceItems.filter((item) =>
    item.serviceName.toLowerCase().includes(serviceSearchQuery.toLowerCase())
  );

  const addMedicine = () => {
    if (!selectedMedicine) return;
    const selectedMedicineObjs = pharmaItems?.find(
      (item) => item.itemName === selectedMedicine
    );
    const matchedDose = dose.find((d) => d.doseText === selectedDose);
    if (selectedMedicineObjs && matchedDose) {
      const newItem: MedicineObject = {
        itemCode: selectedMedicineObjs?.itemCode,
        itemName: selectedMedicineObjs?.itemName,
        forDays: days,
        doseId: matchedDose?.doseId,
        qty: parseInt(days) * matchedDose?.doseValue,
      };
      setSelectedMedicineObj([...selectedMedicineObj, newItem]);
    }

    if (selectedMedicineObjs && !medicines.includes(selectedMedicine)) {
      setMedicines([...medicines, selectedMedicine]);
      // Reset only the search query and form, keep selectedMedicine visible temporarily
      setMedicineSearchQuery("");
      setSelectedMedicine("");
      setDays("");
      setSelectedDose("");
    }
  };

  const addServices = () => {
    if (!selectedServices) return;
    const selectedServiceObjs = serviceItems.find(
      (item) => item.serviceName === selectedServices
    );
    if (selectedServiceObjs) {
      const newItem: ServicesObject = {
        serviceId: selectedServiceObjs.labItemId,
        serviceUnitPrice: selectedServiceObjs.servicePrices,
        isApplied: false,
      };
      setSelectedServiceObj([...selectedServiceObj, newItem]);
    }
    if (!services.includes(selectedServices)) {
      setServices([...services, selectedServices]);
      // Reset only the search query, keep selectedService visible temporarily
      setServiceSearchQuery("");
      setSelectedServices("");
    }
  };

  const removeServices = (index: number) => {
    const updated = [...services];
    updated.splice(index, 1);
    setServices(updated);
  };

  const removeMedicine = (index: number) => {
    const updated = [...medicines];
    updated.splice(index, 1);
    setMedicines(updated);
  };

  const handleIconClick = () => {
    if (inputRef.current) {
      try {
        inputRef.current.showPicker?.();
        inputRef.current.focus();
      } catch (error) {
        console.error("showPicker failed:", error);
      }
    }
  };

  

  const sections = [
    "Chief Complaint",
    "Provisional Diagnosis",
    "Treatment Plan",
    "Medicines",
    "Services",
  ];

  useEffect(() => {
    const fetchPatientProfile = async (patientId: any) => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorforpatientprofiledetails?patientId=${patientId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setProfileImage(response.data?.patientImages[0]?.imagePath);
        setPatientProfile(response.data);
        if (response.data.dob) {
          const birthDate = new Date(response.data.dob);
          const today = new Date();
          const age =
            today.getFullYear() -
            birthDate.getFullYear() -
            (today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() &&
              today.getDate() < birthDate.getDate())
              ? 1
              : 0);
          setAge(age);
        }
      } catch (error: any) {
        console.error("error in Geting PatientProfie");
      }
    };
    fetchPatientProfile(patientId);
  }, [patientId]);

  

  const fetchPharmaTerm = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/GetPharmaItem`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPharmaItems(response.data);
    } catch (error) {
      console.error("Error fetching fetchPharmaTerm details:", error);
    }
  };

  useEffect(() => {
    fetchPharmaTerm();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/GetLabItem`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setServiceItems(response.data);
    } catch (error) {
      console.error("Error fetchServices  details:", error);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchDose = async () =>{
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoseDetail`
      );
      setDose(response.data);
    } catch (error) {
      console.error("Error fetching dose details:", error);
    }
  };

  useEffect(() => {
    fetchDose();
  }, []);

  const submitDiagnoses = async () => {
    const payLoad = {
      appointmentId: appointmentId,
      cheifComplain: chiefComplaint,
      provisionalDiagnosis: provisionalDiagnosisString,
      treatmentPlan: treatmentPlan,
      medicines: medicinesString,
      service: selectedServicesString,
      createdBy: userId,
      followUpDate: date,
    };
    const investigationPayload = {
      appointmentId: appointmentId,
      createdBy: userId,
      details: selectedServiceObj,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/AppointmentDiagnosis`,
        payLoad,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const investigationResponse = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/CreateInvestigationOrder`,
        investigationPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const medicinePayload = {
        appointmentId: appointmentId,
        createdBy: userId,
        details: selectedMedicineObj,
      };
      const medcineResponse = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/CreateMedicineRequisition`,
        medicinePayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (medcineResponse.data) {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/UpdateAppointmentStatus`,
          null,
          {
            params: {
              AppointmentId: appointmentId,
              doctorid: userId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        closePopup();
        window.location.reload();

      }
    } catch (error) {
      console.error("Error submitDiagnoses details:", error);
    }
  };

  const searchAPI = async (searchTerm: any) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Diagnosis/search`,
        {
          params: {
            keyword: searchTerm,
          },
        }
      );
      const rawData: Diagnosis[] = response.data;

      const cleanedData: any = rawData.map((item) => ({
        ...item,
        title: item.title.replace(/<\/?em[^>]*>/g, ""),
      }));
      setResults(cleanedData);
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  useEffect(() => {
    if (searchQuery !== "") {
      searchAPI(searchQuery);
    } else {
      setResults([]);
    }
  }, [searchQuery]);
const validateBeforeSubmit = () => {
  const newErrors: any = {};

  if (provisionalDiagnosis.length === 0) {
    newErrors.diagnosis = "At least one provisional diagnosis is required.";
  }

  if (!date) {
    newErrors.followUpDate = "Follow-up date is required.";
  }

  setErrors(newErrors);

  // return true only if no errors
  return Object.keys(newErrors).length === 0;
};

  return (
    <div className="absolute w-full bg-gray-100 h-full">
      {showConfirmModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-lg w-[380px] p-6 shadow-xl">
    
      <h2 className="text-lg font-semibold text-gray-800 mb-2">
        Confirm Appointment
      </h2>

  
      <p className="text-sm text-gray-600 mb-6">
        Are you sure you want to complete the appointment with the patient
        and add the follow-up date?
      </p>

  
      <div className="flex justify-end gap-3">
        <button
          onClick={() => setShowConfirmModal(false)}
          className="px-4 py-1 rounded-md border text-gray-600 hover:bg-gray-100"
        >
          Cancel
        </button>

        <button
  disabled={Object.keys(errors).length > 0}
  onClick={() => {
    submitDiagnoses();
    setShowConfirmModal(false);
  }}
  className={`px-4 py-1 rounded-md text-white ${
    Object.keys(errors).length > 0
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-[#184A84] hover:bg-blue-700"
  }`}
>
  Yes, Confirm
</button>

      </div>
    </div>
  </div>
)}

      <div className="w-full p-4 ">
        {/* Patient Header */}
        <div className="flex items-center justify-around bg-[#184A84] text-white p-4 rounded-lg mt-5">
          {profileImage ? (
            <img
              src={`${process.env.REACT_APP_BASE_URL}${profileImage}`}
              alt="Profile"
              className="w-14 h-14 rounded-full border-2 border-white"
            />
          ) : (
            <img
              src={Avtar}
              alt="Patient"
              className="w-14 h-14 rounded-full border-2 border-white"
            />
          )}

          <div className="ml-4">
            <p className="text-green-300 text-sm">PatientId-{patientId}</p>
            <h2 className="text-lg font-semibold">
              {patientProfile?.patientName}
            </h2>
            <p className="text-sm">Age-{age}</p>
          </div>
          <div className="ml-auto text-right">
            <p className="text-sm text-gray-300">Allergies</p>
            <p className="text-white font-bold"> {patientProfile?.allergies}</p>
          </div>
        </div>

        <div className="mt-4 overflow-y-auto h-[75vh]">
          {sections.map((section, index) => (
            <div
              key={index}
              className={`border-b last:border-none text-[12px]  ${
                openSection === index ? "text-blue-300" : "bg-white"
              } transition-all duration-300`}
            >
              <button
                className="w-full flex justify-between items-center p-3 text-gray-900 font-medium focus:outline-none"
                onClick={() =>
                  setOpenSection(openSection === index ? null : index)
                }
              >
                {section}
                {openSection === index ? (
                  <FiChevronUp className="w-5 h-5 text-gray-900" />
                ) : (
                  <FiChevronDown className="w-5 h-5 text-gray-500" />
                )}
              </button>

              {openSection === index && (
                <div className="p-1 text-gray-600 bg-[#CDCDCD] p-2">
                  {section === "Chief Complaint" && (
                    <div className="space-y-3 text-[12px]">
                      <textarea
                        className="w-full p-2 border rounded-md min-h-[100px]"
                        placeholder="Enter Chief Complaint"
                        value={chiefComplaint}
                        onChange={(e) => setChiefComplaint(e.target.value)}
                      ></textarea>
                    </div>
                  )}

                  {section == "Treatment Plan" && (
                    <div className="space-y-3 text-[12px]">
                      <textarea
                        className="w-full p-2 border rounded-md min-h-[100px]"
                        placeholder="Treatment Plan"
                        rows={4}
                        value={treatmentPlan}
                        onChange={(e) => setTreatmentPlan(e.target.value)}
                      ></textarea>
                    </div>
                  )}

                  {section == "Provisional Diagnosis" && (
                    <div className="flex gap-2 flex-col">
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search for a diagnosis"
                        className="p-2 border rounded-md mb-2"
                      />
                      <select
                        value={selectedDiagnosis}
                        onChange={(e) =>
                          setSelectedDiagnosis(
                            Array.from(
                              e.target.selectedOptions,
                              (option) => option.value
                            )
                          )
                        }
                        className="flex-1 p-2 border rounded-md"
                      >
                        <option value="">Choose a diagnosis</option>
                        {results.map((diagnosis: any, index) => (
                          <option key={index} value={diagnosis.title}>
                            {diagnosis.title}
                          </option>
                        ))}
                      </select>

                      <button
                        type="button"
                        onClick={() => {
                          const newItems = selectedDiagnosis.filter(
                            (item) => !provisionalDiagnosis.includes(item)
                          );
                          setProvisionalDiagnosis([
                            ...provisionalDiagnosis,
                            ...newItems,
                          ]);
                          setSelectedDiagnosis([]);
                        }}
                        className="px-3 py-1 bg-blue-600 text-white rounded-md text-sm w-full"
                      >
                        Add
                      </button>

                      <div>
                        <label className="block text-sm font-medium mb-1">
                          Selected Diagnoses
                        </label>
                        <div className="flex flex-wrap gap-2 bg-white p-1 border rounded min-h-[30px]">
                          {provisionalDiagnosis?.length === 0 ? (
                            <span className="text-gray-400 text-sm">
                              No diagnoses added
                            </span>
                          ) : (
                            provisionalDiagnosis?.map((diag, index) => (
                              <div
                                key={index}
                                className="flex items-center bg-blue-100 text-blue-800 px-3  rounded-full text-xs"
                              >
                                {diag}
                                <button
                                  onClick={() =>
                                    setProvisionalDiagnosis(
                                      provisionalDiagnosis?.filter(
                                        (d) => d !== diag
                                      )
                                    )
                                  }
                                  className="ml-2 text-red-600 hover:text-red-800"
                                >
                                  X
                                </button>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  

                  {section === "Services" && (
                    <div className="flex flex-col gap-2">
                      <div className="relative">
                        <div className="flex items-center border rounded-md bg-white">
                          <input
                            type="text"
                            value={
                              serviceSearchQuery || selectedServices
                            }
                            onChange={(e) => setServiceSearchQuery(e.target.value)}
                            onFocus={() => setShowServiceDropdown(true)}
                            placeholder="Search services..."
                            className="w-full p-2 outline-none rounded-md"
                          />
                        </div>

                        {/* Service Dropdown */}
                        {showServiceDropdown && (
                          <div className="absolute top-full left-0 right-0 bg-white border border-t-0 rounded-b-md max-h-48 overflow-y-auto z-50 shadow-lg">
                            {filteredServices.length > 0 ? (
                              filteredServices.map((service) => (
                                <div
                                  key={service?.labItemId}
                                  onClick={() => {
                                    setSelectedServices(service?.serviceName);
                                    setServiceSearchQuery("");
                                    setShowServiceDropdown(false);
                                  }}
                                  className="p-2 hover:bg-gray-100 cursor-pointer text-sm"
                                >
                                  {service?.serviceName}
                                </div>
                              ))
                            ) : (
                              <div className="p-2 text-sm text-gray-400">
                                No services found
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Button to add service */}
                      <button
                        type="button"
                        onClick={addServices}
                        className="px-3 py-1 bg-blue-600 text-white rounded-md text-sm w-full hover:bg-blue-700"
                      >
                        Add
                      </button>

                      {/* List of selected services */}
                      <div>
                        <label className="block text-sm font-medium mb-1">
                          Selected Services
                        </label>
                        <div className="flex flex-wrap gap-2 bg-white p-1 border rounded min-h-[30px]">
                          {services.length === 0 ? (
                            <span className="text-gray-400 text-sm">
                              No services added
                            </span>
                          ) : (
                            services.map((service, index) => (
                              <div
                                key={index}
                                className="flex items-center bg-green-100 text-green-800 px-3  rounded-full text-xs"
                              >
                                {service}
                                <button
                                  onClick={() => removeServices(index)}
                                  className="ml-2 text-red-600 hover:text-red-800"
                                >
                                  X
                                </button>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {section == "Medicines" && (
                    <div className="space-y-3 text-[12px]">
                      <div>
                        <div className="mt-4">
                          <label className="block text-xs font-medium mb-1">
                            Search Medicines
                          </label>

                          {/* Medicine Search Dropdown */}
                          <div className="relative mb-3">
                            <div className="flex items-center border rounded-md bg-white">
                              <input
                                type="text"
                                value={
                                  medicineSearchQuery || selectedMedicine
                                }
                                onChange={(e) =>
                                  setMedicineSearchQuery(e.target.value)
                                }
                                onFocus={() => setShowMedicineDropdown(true)}
                                placeholder="Search medicines..."
                                className="w-full p-2 outline-none rounded-md"
                              />
                            </div>

                            {/* Medicine Dropdown */}
                            {showMedicineDropdown && (
                              <div className="absolute top-full left-0 right-0 bg-white border border-t-0 rounded-b-md max-h-48 overflow-y-auto z-50 shadow-lg">
                                {filteredMedicines.length > 0 ? (
                                  filteredMedicines.map((item) => (
                                    <div
                                      key={item?.itemCode}
                                      onClick={() => {
                                        setSelectedMedicine(item?.itemName);
                                        setMedicineSearchQuery("");
                                        setShowMedicineDropdown(false);
                                      }}
                                      className="p-2 hover:bg-gray-100 cursor-pointer text-sm"
                                    >
                                      {item?.itemName}
                                    </div>
                                  ))
                                ) : (
                                  <div className="p-2 text-sm text-gray-400">
                                    No medicines found
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="flex w-full gap-2 mb-3">
                            {/* Days Dropdown */}
                            <select
                              value={days}
                              onChange={(e) => setDays(e.target.value)}
                              className="p-2 border rounded w-1/2"
                            >
                              <option value="">For Days *</option>
                              {dummyDays.map((d, index) => (
                                <option key={index} value={d}>
                                  {d} days
                                </option>
                              ))}
                            </select>

                            {/* Dose Dropdown */}
                            <select
                              value={selectedDose}
                              onChange={(e) => setSelectedDose(e.target.value)}
                              className="p-2 border rounded w-1/2"
                            >
                              <option value="">Select Dose *</option>
                              {dose?.map((d, index) => (
                                <option key={index} value={d.doseText}>
                                  {d.doseText}
                                </option>
                              ))}
                            </select>
                          </div>

                          <button
                            className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 mb-4 w-full"
                            onClick={addMedicine}
                          >
                            Add Medicines
                          </button>

                          {/* Selected Medicines Display */}
                          <div>
                            <label className="block text-sm font-medium mb-1">
                              Selected Medicines
                            </label>
                            <div className="flex flex-wrap gap-2 bg-white p-1 border rounded min-h-[30px]">
                              {medicines.length === 0 ? (
                                <span className="text-gray-400 text-sm">
                                  No medicines added
                                </span>
                              ) : (
                                medicines.map((med, index) => (
                                  <div
                                    key={index}
                                    className="flex items-center bg-blue-100 text-blue-800 px-3  rounded-full text-xs"
                                  >
                                    {med}
                                    <button
                                      onClick={() => removeMedicine(index)}
                                      className="ml-2 text-red-600 hover:text-red-800"
                                    >
                                      X
                                    </button>
                                  </div>
                                ))
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}

          <div className="mt-5">
            <div className="w-[250px]">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Add Next Follow UP Date?
              </label>
              <div className="flex items-center border-2   rounded px-2 py-1">
                <input
                  type={type}
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  onFocus={() => setType("date")}
                  onBlur={() => {
                    if (!date) setType("text");
                  }}
                  placeholder="DD/MM/YYYY"
                  className="w-full bg-transparent outline-none text-base placeholder-gray-400"
                />
                <img
                  src={calender}
                  alt="calendar"
                  onClick={handleIconClick}
                  className="w-6 h-6 ml-2 cursor-pointer"
                />
              </div>
            </div>
          </div>
          {errors.followUpDate && (
  <p className="text-red-600 text-xs mt-1">
    {errors.followUpDate}
  </p>
)}
        {errors.diagnosis && (
  <p className="text-red-600 text-xs mt-1">
    {errors.diagnosis}
  </p>
)}
        <div className="flex justify-end">
          <button
            onClick={() => {
    const isValid = validateBeforeSubmit();
    if (isValid) {
      setShowConfirmModal(true);
    }
  }}
            className=" text-white font-semibold bg-[#184A84] px-4 py-1 rounded-md bottom-10 right-2"
          >
            Submit
          </button>
        </div>
        </div>

        
      </div>
    </div>
  );
};

export default VideocallMedicationByDoctor;
